import { frontendURL } from '../../../helper/URLHelper';

// Rotas dos módulos nativos. Cada uma declara meta.featureModule: a guarda do
// uz.1 (helper/routeHelpers.js) redireciona para o dashboard quando o módulo
// não está liberado para a empresa. Caminhos absolutos, como as demais filhas
// de accounts/:accountId.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/connections'),
    name: 'connections_index',
    component: () => import('./KanbanConnections.vue'),
    meta: {
      permissions: ['administrator', 'connections_module'],
      featureModule: 'connections',
    },
  },
  {
    path: frontendURL('accounts/:accountId/calls-report'),
    name: 'calls_index',
    component: () => import('./KanbanCalls.vue'),
    meta: {
      permissions: ['administrator', 'agent', 'calls_module'],
      featureModule: 'calls',
    },
  },
];
